var sort = function sort(_ref) {
  var selector = _ref.selector,
    data = _ref.data,
    _ref$descending = _ref.descending,
    descending = _ref$descending === void 0 ? false : _ref$descending;
  data.sort(function (a, b) {
    var propA = selector(a);
    var propB = selector(b);
    if (propA === undefined || propB === undefined) {
      return 0;
    }
    if (descending) {
      if (propA > propB) {
        return -1;
      }
      if (propA < propB) {
        return 1;
      }
    } else {
      if (propA < propB) {
        return -1;
      }
      if (propA > propB) {
        return 1;
      }
    }
    return 0;
  });
  return data;
};
export { sort };
//# sourceMappingURL=sort.js.map